import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  GenericIconName,
  Icon,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const LegalReportSuccessPage: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Wrapper data-testid="legalReportSuccessPage">
      <Icon
        asset={GenericIconName.AlertSuccessFill}
        size="L"
        fill={COLORS.Green3}
      />
      <Headline weight="heavy">{t('Thank you for reporting')}</Headline>
      <Subline size="px16" color="Grey0">
        {t(
          "We'll carefully review your concern and keep you updated on any progress.",
        )}
      </Subline>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;

  ${tabletAndUpLinaria(`
    padding: 3rem 2rem;
    border: 1px solid ${COLORS.Grey3};
    border-radius: 8px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 10px 15px 0px rgba(0, 0, 0, 0.04);
  `)}
`;

const Headline = styled(Text)`
  text-align: center;
  line-height: 1.5;
  font-size: ${FONT_SIZES.px20};

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px32};
  `)}
`;

const Subline = styled(Text)`
  text-align: center;
  line-height: 1.5;
`;
